var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    className: "mainStroke",
    viewBox: "0 0 267 267",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n                fill-rule: evenodd;\r\n                stroke-width: 0px;\r\n            }\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.081,38.792c-3.518,1.334 -6.067,4.731 -6.067,8.25c0,3.276 2.428,5.944 37.125,40.764l37.125,37.246l-115.377,-0c-110.039,-0 -115.497,-0 -117.681,1.819c-3.276,2.668 -3.276,9.949 -0,12.496c2.184,1.819 7.642,1.819 117.681,1.819l115.377,0l-37.125,37.246c-34.697,34.82 -37.125,37.488 -37.125,40.764c0,6.552 6.916,10.555 12.376,7.037c1.82,-1.092 22.93,-21.717 46.951,-45.859c40.643,-40.764 43.675,-44.04 43.675,-47.316c-0,-3.275 -3.032,-6.43 -42.704,-46.344c-23.537,-23.536 -44.525,-44.162 -46.709,-45.738c-4.003,-2.912 -4.974,-3.276 -7.643,-2.184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheR);
export default __webpack_public_path__ + "static/media/fleche-r.95faba41bf9215aa8ca5ac458f17c041.svg";
export { ForwardRef as ReactComponent };